<template>
  <v-bottom-navigation
    v-if="showBottomNav"
    app
    elevation="8"
  >
    <v-btn
      v-for="item in visibleItems"
      :key="item.route"
      :value="item.route"
      :active="routeName === item.route"
      :ripple="true"
      stacked
      @click="go(item.route)"
    >
      <v-icon :icon="item.icon" />
      <span>{{ item.title }}</span>
    </v-btn>
  </v-bottom-navigation>
</template>

<script lang="ts" setup>
import GlobalService from "@/services/global-service";
import { useAppNav } from "@/composables/useAppNav";

const { showBottomNav, routeName, visibleItems } = useAppNav();

async function go(name: string): Promise<void> {
  await GlobalService.router().routeTo(name);
}
</script>
